import * as React from 'react';

export interface ListGroupIgnoreProps {
    requireBefore?: boolean;
    requireAfter?: boolean;
    children: React.ReactNode;
}

/**
 * Children of this component are only rendered in lists if their requirements are met.
 */
export const ListGroupRequire: React.FC<ListGroupIgnoreProps> = (props) => {
    const {children} = props;

    return <>{children}</>;
};

